// popup on problems and solutions grid layout

function firePopupContentSlide() {
    $('.js-slide-popup-content').on('click', function(){
        var $this = $(this);
        var container = $this.closest(".js-popup-content");
        var heading = container.find('.js-popup-heading');

        if(container.hasClass('is-active')) {
            container.removeClass('is-active')
        } else {
            container.addClass('is-active');
        }

    });
}

firePopupContentSlide();
